import { CommonModule, ViewportScroller } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { OpePit } from 'src/app/models/OpePit';
import { sharePitSevices } from 'src/app/services/pitupload/sharePit.service';
import { shareOpeSevices } from 'src/app/services/sharedservices/shareOpe.services';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-pitupload-nav',
  templateUrl: './pitupload-nav.component.html',
  imports: [CommonModule,FormsModule,RouterOutlet,MenuModule,TooltipModule],
  styleUrls: ['./pitupload-nav.component.scss']
})
export class PituploadNavComponent implements OnInit {
  items: MenuItem[] | undefined;
  mobileDisplay!: boolean;

  programme!: OpePit;
  styleclasse: string = '';

  @HostListener('window:resize', ['$event.target.innerWidth'])

  onResize(width: number) {
    if (width <= 992) {
      this.mobileDisplay = true;
    } else {
      this.mobileDisplay = false;
    }
  }


  constructor(public sharePitSevices: sharePitSevices, private scroller: ViewportScroller, public share: shareOpeSevices) { }
  ngOnInit() {

    // charger le nom et les info du programme sur la navbar
    //this.share.datasOpe$.subscribe(res => this.programme = res);

    this.items = [
      {
        label: 'Présentation',
        icon: 'icon-inc icon-building-invert',
        command: () => {
          this.share.isPitUploadDisplayPres = true,
            this.share.isPitUploadDisplayEspaceVente = false,
            this.share.isPitUploadDisplayPlansPublication = false,
            this.share.isPitUploadDisplayDocument = false,
            this.share.isPitUploadDisplaygalerie = false
        },
        styleClass: this.styleclasse
      },

      {
        label: 'Galerie photos',
        icon: 'icon-inc icon-camera-invert',
        command: () => {
          this.share.isPitUploadDisplaygalerie = true,
            this.share.isPitUploadDisplayPres = false,
            this.share.isPitUploadDisplayEspaceVente = false,
            this.share.isPitUploadDisplayPlansPublication = false,
            this.share.isPitUploadDisplayDocument = false
        },
        styleClass: this.styleclasse
      },

      {
        label: 'Documents',
        icon: 'icon-inc icon-document-invert',
        command: () => {
          this.share.isPitUploadDisplayDocument = true,
            this.share.isPitUploadDisplayEspaceVente = false,
            this.share.isPitUploadDisplayPres = false,
            this.share.isPitUploadDisplayPlansPublication = false,
            this.share.isPitUploadDisplaygalerie = false,
            this.setActiveClass(true)
        },

        styleClass: this.styleclasse

      },

      {
        label: 'Espace de vente',
        icon: 'icon-inc icon-handshake-invert',
        command: () => {

          this.share.isPitUploadDisplayPlansPublication = false,
            this.share.isPitUploadDisplayEspaceVente = true,
            this.share.isPitUploadDisplayPres = false,
            this.share.isPitUploadDisplayDocument = false,
            this.share.isPitUploadDisplaygalerie = false
        },
        styleClass: this.styleclasse

      },

      {
        label: 'Plans et publication lots',
        icon: 'icon-inc icon-lots-invert',
        command: () => {

          this.share.isPitUploadDisplayEspaceVente = false,
            this.share.isPitUploadDisplayPres = false,
            this.share.isPitUploadDisplayDocument = false,
            this.share.isPitUploadDisplaygalerie = false,
            this.share.isPitUploadDisplayPlansPublication = true
        },
        styleClass: this.styleclasse

      }
    ];

    if (window.innerWidth <= 768) { // 768px portrait
      this.mobileDisplay = true;
    }

    this.programme = this.sharePitSevices.pituploadSelectedOpe;

    this.share.isPitUploadDisplayPres = true,
      this.share.isPitUploadDisplayEspaceVente = false,
      this.share.isPitUploadDisplayPlansPublication = false,
      this.share.isPitUploadDisplayDocument = false,
      this.share.isPitUploadDisplaygalerie = false

  }


  setActiveClass(t: boolean) {
    if (t == true) { return this.styleclasse = 'emphasis' } else return this.styleclasse;
  }

}
